import { useState } from "react";
import { ConfirmSaveChange } from "../../../../../general/popup";
import { callTokenApi } from "../../../../../../apiCaller";
import { toast } from 'react-toastify';
import CIcon from '@coreui/icons-react';
import { useSelector } from "react-redux";

export default function SavePreviewResults({ jobId }) {
    const [showModal, setShowModal] = useState(false);
    const accountId = useSelector((state) => state.subscriber.activeAccount?.accountId);

    const onAccept = async () => {
        const response = await callTokenApi('client/ai-insight-jobs/save-results', 'POST', {
            accountId,
            jobId,
            isSaveResult: true,
        });

        if (response?.status === 200) {
            setShowModal(false);
            toast.success(`Save result successfully.`);
        }
    }

    return (
        <>
            <div className="d-flex align-items-center pointer ml-auto gap-1 pl-1" onClick={() => setShowModal(true)}>
                <CIcon icon="cilSave" height={15} width={15} className="icon-ai-insight save" />
                <span className='pt-1'>Save</span>
            </div>

            <ConfirmSaveChange
                show={showModal}
                title="Save Preview Results"
                btnTextSave={"Save"}
                onAccept={onAccept}
                onClose={() => setShowModal(false)}
                className="save-results"
            >
                <p>This will permanently save these results so that you can view them in the history of results from this AI Insight.</p>
            </ConfirmSaveChange>
        </>
    );
}